<template>
  <header v-if="!isViewerPage" class="flex items-center py-4" :class="isBackButtonVisible ? 'justify-between sm:ml-0 ml-16' : 'justify-end'">
    <router-link :to="{ name: 'viewerMain' }" v-if="isBackButtonVisible" v-slot="{ href, navigate }">
      <a data-testid="viewer-header-back-button" :href="href" @click="navigate">
        <Button type="link" variant="black" icon="general.backArrow">Back </Button>
      </a>
    </router-link>
    <div class="flex gap-2 justify-content">
      <BrandingContent>
        <Button
          v-if="isCtaVisible"
          data-testid="viewer-header-get-cloudapp-button"
          type="solid"
          variant="orange"
          icon="general.stars"
          @click.stop.prevent="signUpClick()"
        >
          Get Zight <span class="hidden sm:inline">for Free</span>
        </Button>
      </BrandingContent>
      <Button @click.stop.prevent="signInClick()" type="link" variant="black" icon="general.signIn" data-testid="show-sign-in-modal">Sign In</Button>
    </div>
  </header>
</template>
<script lang="ts" setup>
import { useAuthModals } from '@/composables/useAuthModals';
import { useIsViewerPage } from '@/composables/useIsViewerPage';
import BrandingContent from '@/components/BrandingContent.vue';
import { useLayoutStore } from '@/store/useLayoutStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { storeToRefs } from 'pinia';
import { TrackEvents, useTrack } from '@/composables/useTrack';
import { Button } from '@/storybook';

const { isCtaVisible, isBackButtonVisible } = storeToRefs(useLayoutStore());

// Narrow dep on itemStore: used only to include the item hashid in click
// tracking. Not used for route detection — that was a code smell, and it's
// now handled through the shared viewer-page route composable.
const itemStore = useViewerItemStore();
const { id } = storeToRefs(itemStore);

// Hide on viewer pages — the GuestTopBar handles CTAs there.
const isViewerPage = useIsViewerPage();

const { showSignInModal, showSignUpModal } = useAuthModals();
const { track } = useTrack();

const signInClick = () => {
  showSignInModal();
  track(TrackEvents.SIGN_IN_CLICK, { viewer: 'copernicus', hashid: id?.value });
};

const signUpClick = () => {
  showSignUpModal();
  track(TrackEvents.SIGN_UP_CLICK, { viewer: 'copernicus', hashid: id?.value });
};
</script>
